import find from 'lodash/find';
import get from 'lodash/get';
import { Module } from 'vuex';
import { ActionContext, DefineActions, DefineMutations } from 'vuex-type-helper';
import { africaOptions, toursData } from '../../globals';
import DiscountCampaigns from '../../models/DiscountCampaigns';
import { RootState } from '../index';

export interface DiscountBannerSetting {
    enabled: boolean;
    bgColor: string;
    fontColor: string;
    icon: string;
}

export interface Discount {
    id: number;
    code: string;
    name: string;
    isForAllTours: boolean;
    startedAt: string;
    endedAt: string;
    departureStart: string | null;
    departureEnd: string | null;
    comment: string;
    bannerSettings: DiscountBannerSetting;
}

export interface ModuleState {
    discounts: Discount[];
}

export interface ModuleMutations {
    fetchDiscounts: Discount[];
}

export interface ModuleActions {
    fetchDiscounts;
}

const state: ModuleState = {
    discounts: [],
};

const actions: DefineActions<ModuleActions, ModuleState, ModuleMutations> = {
    fetchDiscounts(s: ActionContext<ModuleState, {}, ModuleActions, ModuleMutations>) {
        let tourId: number | undefined;
        let destinationId: number | undefined;
        const ctrl: string = get(africaOptions, 'page.controller');
        switch (ctrl) {
            case 'tour':
                tourId = parseInt(get(africaOptions, 'page.id'), 10);
                destinationId = parseInt(get(find(toursData, { id: tourId }), 'destination.id'), 10);
                break;
            case 'destination':
                destinationId = parseInt(get(africaOptions, 'page.id'), 10);
                break;
            case 'practical-info':
                destinationId = parseInt(get(africaOptions, 'page.destinationId'), 10);
                break;
            case 'blog':
                destinationId = parseInt(get(africaOptions, 'page.blogDestinations'), 10);
                break;
            default:
                break;
        }

        DiscountCampaigns.search({ tour: tourId, destination: destinationId }).then((response: any) => {
            s.commit('fetchDiscounts', response);
        });
    },
};

const mutations: DefineMutations<ModuleMutations, ModuleState> = {
    fetchDiscounts(s, discounts) {
        s.discounts = discounts;
    },
};

const module: Module<ModuleState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/discounts.ts